// extracted by mini-css-extract-plugin
export default {"header":"Header_header__x42Ml","logo":"Header_logo__+-i0A","logout":"Header_logout__f3V93"};